import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { runtimeEnv } from '../../runtimeEnv';

let ai: ApplicationInsights | null = null;

export function initAppInsights(): void {
  if (!runtimeEnv.appinsightsConnectionString || ai) return;
  ai = new ApplicationInsights({
    config: {
      connectionString: runtimeEnv.appinsightsConnectionString,
      enableAutoRouteTracking: true,
      distributedTracingMode: 2, // AI_AND_W3C — emit traceparent
      disableFetchTracking: false,
    },
  });
  ai.loadAppInsights();
  ai.context.application.ver = runtimeEnv.buildSha;
  ai.trackPageView();
}

export function getAppInsights(): ApplicationInsights | null {
  return ai;
}

// Real W3C correlation ids from the active operation — not a random UUID.
export function getTraceContext(): { trace_id: string; span_id: string } {
  const t = ai?.context?.telemetryTrace;
  return { trace_id: t?.traceID ?? '', span_id: t?.parentID ?? '' };
}
